import baseURL from "../config/api";
import axios from "../config/axios";

export const post_SubLesson = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}sublessons?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_SubLesson = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}sublessons?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const delete_SubLesson = (primaryKey: number, userId:number) => {
    return axios({
        url: `${baseURL}sublessons?id=${primaryKey}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}

export const post_SubLessonContent = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}contents?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);

}

export const put_SubLessonContent = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}contents?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);

}

export const delete_SubLessonContent = (primaryKey: number, userId:number) => {
    return axios({
        url: `${baseURL}contents?id=${primaryKey}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}


export const post_SubLessonVideo = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}videos?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_SubLessonVideo = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}videos?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);

}

export const delete_SubLessonVideo = (primaryKey: number, userId:number) => {
    return axios({
        url: `${baseURL}videos?id=${primaryKey}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}

export const getSubLessonsByLesson = (lessonId: number) => {
    return getFetch(`sublessons/GetSubLessonsByLessonId/${lessonId}`);
}

export const getContentBySubLesson = (subLessonId: number) => {
    return getFetch(`contents/GetContentsBySubLessonId/${subLessonId}`);
}

export const getVideoBySubLesson = (subLessonId: number) => {
    return getFetch(`videos/GetVideosBySubLessonId/${subLessonId}`);
}

export const getContent = (contentId: number) => {
    return getFetch(`contents/${contentId}`);
}

export const getVideo = (videoId: number) => {
    return getFetch(`videos/${videoId}`);
}


export const getSubLessonOrder = (subLessonId: number) => {
    return getFetch(`subLessonOrders/GetSubLessonOrderReportBySubLessonId/${subLessonId}`);
}

export const getSubLessonBySearch = (searchValue: string, page:number, size:number) => {
    return getFetch(`sublessons/GetSubLessonPagingByKeywordSearch?keyword=${searchValue}&page=${page}&size=${size}`);
}

export const post_SubLessonOrder = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}subLessonOrders?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_BulkSubLessonOrder = (data: any[], userId: number) => {
    return axios({
        url: `${baseURL}subLessonOrders/BulkUpdateSubLessonOrder?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}


const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}